import React, {Component} from 'react';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'
import "../CSS/appointment.css"
import CirclePlus from '../images/CirclePlus.svg'
import WorkIcon from '../images/business.png'
import AppointmentService from '../utils/AppointmentService.js';

export default class SelectBuildings extends Component {
  constructor(props){
    super(props)
    this.nearbyLocations = this.nearbyLocations.bind(this);
    this.saveLocation = this.saveLocation.bind(this);
    this.Appt = new AppointmentService(),
    this.state = {
      buildings: props.buildings
    }
  }
  nearbyLocations(buildings) {
      var buildingsHTML = []
      var outerThis = this
      if(buildings){
      buildings.forEach(function(building) {
          buildingsHTML.push(<li className="list-group-item"><a onClick={() => outerThis.saveLocation(building)} className='link' href="#"><img className="mr-3 constant-size" src={WorkIcon}></img>{building.street} {building.street_adtl}</a></li>)
      });

      return buildingsHTML;
    }
  }
  saveLocation(building){
  var outerThis = this
    this.Appt.saveNewAddress(building.street, building.city, building.state_abbr, building.postal, building.display_title, building.street_adtl)
           .then(res =>{
             if(res){
               outerThis.props.selectLocation(res.address)
             }
             else{
               throw new Error('Error Saving Location' + res);
             }
           //  this.props.history.replace('/');
           })
           .catch(err =>{
               throw new Error('Error Saving Location' + err.message);
           })
           this.props.closeModal()

  }
  render() {
    return (
        <div className="selectRSL">
          <div className="card full-width">
            <div className="full-width card-header bg-primary text-white text-center ">
              <h4>Almost There, Let's find your exact Building</h4>
            </div>
            <ul className="list-group list-group-flush align-content-center">
            {this.nearbyLocations(this.props.buildings)}
            </ul>
          </div>
          <div className="form-group">
            <button className="btn btn-primary btn-block text-white text-center" onClick={() => this.props.showForm()} >Enter New Address</button>
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/SelectBuildings.js